import React, { useState } from "react";
import ServiceForget from "./ServiceForget/ServiceForget";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
const ConfirmPwd = (props, match) => {
  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  const [password, setPassword] = useState("");
  const [Cpassword, setCpassword] = useState("");
  const [email, setEmail] = useState(props.match.params.email);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [sevirity, setSevirity] = useState("");
  const handleClose = () => {
    setOpen(false);
  };

  // console.log(password, Cpassword, email);

  const HandelClick = () => {
    ServiceForget.postconfirmation(email, password, Cpassword).then((res) => {
      if (res.data.message.toString() === "Mot de passe changé avec succès") {
        setMessage("Mot de passe changé avec succès");
        setSevirity("success");
        setOpen(true);
        window.location.replace("/");
      } else {
        setMessage("les mots de pas sont pas identique!");
        setSevirity("error");
        setOpen(true);
      }
    });
  };

  return (
    <>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={sevirity}>
          {message}
        </Alert>
      </Snackbar>
      <div
        style={{
          width: "500px",
          padding: "10px",
          borderRadius: "10px",
          margin: "20px auto",
          backgroundColor: "white",
          boxShadow:
            "0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22)",
        }}
      >
        <h6 className="title" style={{ textAlign: "center" }}>
          Réinitialiser mot de passe
        </h6>
        <br />
        <div className="input-field" style={{ margin: "auto" }}>
          <input
            type="password"
            placeholder="Entrez mot de passe"
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <br />
        <div className="input-field" style={{ margin: "auto" }}>
          <input
            type="password"
            placeholder="Confirmer mot de passe"
            onChange={(e) => setCpassword(e.target.value)}
          />
        </div>
        <br />
        <button
          onClick={() => HandelClick()}
          className="btn2 home"
          style={{ width: "200px", textAlign: "center", marginLeft: "125px" }}
        >
          Envoyer
        </button>
      </div>
    </>
  );
};
export default ConfirmPwd;
